import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CANCEL: `${cleanedFilename(__filename)}-cancel`,
  SUCCESS: `${cleanedFilename(__filename)}-success`,
  ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
  ACCOUNTS_LINK: `${cleanedFilename(__filename)}-accounts-link`,
};
